export const ERestaurantServiceType = {
  Delivery: 0,

  Local: 1,

  Both: 2,
} as const

export type ERestaurantServiceType = (typeof ERestaurantServiceType)[keyof typeof ERestaurantServiceType]
